import { usePlanStatus } from 'src/hooks/usePlanStatusHook';
import type { StudioFeature } from 'src/routes/settings/plans/components/studio/studioFeatureGating';

/**
 * Whether a Studio-pricing workspace lacks the entitlement for `feature`. Used by
 * full-page {@link StudioFeatureUpgradeBanner} gates and inline controls (e.g. a
 * locked dropdown option). Classic workspaces are never locked here; they keep
 * their own plan gating.
 *
 * Studio workspaces fail closed while the plan is unresolved: `hasFeatureAccess`
 * treats an in-flight plan as freemium, so paid options stay locked until Pro+
 * is confirmed rather than flashing unlocked.
 */
export const useStudioFeatureLock = (feature: StudioFeature): boolean => {
  const { studio } = usePlanStatus();
  return studio.isStudioPricingWorkspace && !studio.hasFeatureAccess(feature);
};
